import { AxiosResponse } from 'axios'
import { HttpClient } from '@opallabs/api'

type Params = {
  workflowId: string
  entity: 'story' | 'moment'
  entityId: string
}

type CreateContext = (params: Params) => Promise<AxiosResponse>

const createContext: CreateContext = ({ workflowId, entity, entityId }) => {
  const contextAtrributes = {
    data: {
      type: 'context',
      attributes: {
        [`${entity}_id`]: `${entityId}`,
      },
      relationships: {
        workflow: {
          data: {
            id: workflowId,
            type: 'workflow',
          },
        },
      },
    },
  }

  return HttpClient().post(
    `${window.location.origin}/workflows/v2/contexts?include=workflow,workflow.stages`,
    contextAtrributes
  )
}

export default createContext
